import React from 'react';
import tpl from '../templates/list';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView.js';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'Transfers.Views.List';
}
